// src/components/AboutSection.js
import React, { useContext } from "react";
import { motion } from "framer-motion";
import { Info, Search, FolderOpen, ExternalLink } from "lucide-react";
import { AppContext } from "../App";

const AboutSection = () => {
  const { language } = useContext(AppContext);

  const content = {
    el: {
      title: "Σχετικά με το VrestoEdo.gr",
      text1:
        "Το VrestoEdo.gr είναι μια πλατφόρμα που συγκεντρώνει όλους τους χρήσιμους συνδέσμους για έγγραφα και υπηρεσίες σε ένα μέρος.",
      text2:
        "Στόχος μας είναι να κάνουμε πιο εύκολη και γρήγορη την πρόσβαση σε δημόσια έγγραφα και διάφορες online υπηρεσίες που χρειάζονται συχνά οι πολίτες.",
      notice:
        "Η σελίδα δε συλλέγει ΚΑΝΕΝΟΣ είδους προσωπικά στοιχεία και περιορίζεται μόνο στην παροχή των απαραίτητων συνδέσμων προς έγγραφα και υπηρεσίες.",
      features: [
        { icon: Search, title: "Εύκολη Αναζήτηση", desc: "Βρείτε γρήγορα το έγγραφο που χρειάζεστε" },
        { icon: FolderOpen, title: "Οργανωμένα", desc: "Όλα τα έγγραφα σε κατηγορίες" },
        { icon: ExternalLink, title: "Άμεση Πρόσβαση", desc: "Άμεσοι σύνδεσμοι προς τις επίσημες πηγές" },
      ],
    },
    en: {
      title: "About VrestoEdo.gr",
      text1:
        "VrestoEdo.gr is a platform that gathers all useful links for documents and services in one place.",
      text2:
        "Our goal is to make access to public documents and online services faster and easier for citizens.",
      notice:
        "This site does not collect ANY personal data and is limited solely to providing official public document and service links.",
      features: [
        { icon: Search, title: "Easy Search", desc: "Quickly find the document you need" },
        { icon: FolderOpen, title: "Organized", desc: "All documents sorted by category" },
        { icon: ExternalLink, title: "Direct Access", desc: "Instant links to official resources" },
      ],
    },
  };

  const lang = content[language];

  return (
    <motion.section
      className="relative z-0 w-full mt-24 mb-16 flex flex-col items-center pointer-events-none"
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
      viewport={{ once: true }}
    >
      {/* ✅ Το εσωτερικό div διατηρεί pointer-events, ώστε να λειτουργούν κανονικά τα κουμπιά */}
      <div className="about-glass max-w-4xl px-8 py-10 rounded-2xl text-center pointer-events-auto">
        <h2 className="text-2xl font-semibold tracking-wide mb-3">{lang.title}</h2>
        <p className="text-blue-100 leading-relaxed mb-3">{lang.text1}</p>
        <p className="text-blue-100 leading-relaxed mb-6">{lang.text2}</p>

        <div className="border border-blue-400/40 rounded-lg p-4 mb-8 bg-blue-500/10">
          <Info size={20} className="text-blue-300 inline-block mr-2" />
          <span className="text-blue-100">{lang.notice}</span>
        </div>

        <div className="grid md:grid-cols-3 gap-6 mt-6">
          {lang.features.map((f, i) => (
            <div key={i} className="flex flex-col items-center">
              <f.icon className="text-blue-300 text-3xl mb-3" size={30} />
              <p className="font-semibold">{f.title}</p>
              <p className="text-blue-100 text-sm">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </motion.section>
  );
};

export default AboutSection;
